import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
const MultiValueRemove = /*#__PURE__*/React.memo(props => {
  const onClick = e => {
    e.stopPropagation();
    let newValue = [];
    if (props.selectProps?.value?.length > 0) {
      newValue = props.selectProps.value.filter(current => {
        return current.value !== props.data.value;
      });
    }
    props.selectProps.onChange(newValue, {
      action: 'remove-value',
      option: props.data
    });
  };
  return components.MultiValueRemove && /*#__PURE__*/React.createElement(components.MultiValueRemove, props, /*#__PURE__*/React.createElement(Icon, {
    name: "closeSmall",
    onClick: onClick
  }));
});
MultiValueRemove.displayName = 'MultiValueRemove';
export default MultiValueRemove;